// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Spice = require("@greenlabs/ppx-spice/src/rescript/Spice.bs.js");
var Belt_Id = require("@rescript/std/lib/js/belt_Id.js");
var Js_dict = require("@rescript/std/lib/js/js_dict.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var Belt_Set = require("@rescript/std/lib/js/belt_Set.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Belt_Result = require("@rescript/std/lib/js/belt_Result.js");

var _map = {"external_":"external","preference":"preference","other":"other","internal":"internal"};

var _revMap = {"external":"external_","preference":"preference","other":"other","internal":"internal"};

function linkKindToJs(param) {
  return _map[param];
}

function linkKindFromJs(param) {
  return _revMap[param];
}

function geoblocking_encode(geoblocking) {
  if (geoblocking === "EUR_DE_FR") {
    return "EUR_DE_FR";
  } else if (geoblocking === "ALL") {
    return "ALL";
  } else if (geoblocking === "SAT") {
    return "SAT";
  } else {
    return "DE_FR";
  }
}

function geoblocking_decode(geoblocking) {
  var match = Js_json.decodeString(geoblocking);
  if (match === undefined) {
    return Spice.error(undefined, "Not a valid geoblocking", geoblocking);
  }
  switch (match) {
    case "ALL" :
        return {
                TAG: /* Ok */0,
                _0: "ALL"
              };
    case "DE_FR" :
        return {
                TAG: /* Ok */0,
                _0: "DE_FR"
              };
    case "EUR_DE_FR" :
        return {
                TAG: /* Ok */0,
                _0: "EUR_DE_FR"
              };
    case "SAT" :
        return {
                TAG: /* Ok */0,
                _0: "SAT"
              };
    default:
      return Spice.error(undefined, "Not a valid geoblocking", geoblocking);
  }
}

var geoblockingOrdered = [
  "DE_FR",
  "EUR_DE_FR",
  "SAT",
  "ALL"
];

function language_encode(language) {
  if (language === "en") {
    return "en";
  } else if (language === "es") {
    return "es";
  } else if (language === "fr") {
    return "fr";
  } else if (language === "it") {
    return "it";
  } else if (language === "pl") {
    return "pl";
  } else {
    return "de";
  }
}

function language_decode(language) {
  var match = Js_json.decodeString(language);
  if (match === undefined) {
    return Spice.error(undefined, "Not a valid language", language);
  }
  switch (match) {
    case "de" :
        return {
                TAG: /* Ok */0,
                _0: "de"
              };
    case "en" :
        return {
                TAG: /* Ok */0,
                _0: "en"
              };
    case "es" :
        return {
                TAG: /* Ok */0,
                _0: "es"
              };
    case "fr" :
        return {
                TAG: /* Ok */0,
                _0: "fr"
              };
    case "it" :
        return {
                TAG: /* Ok */0,
                _0: "it"
              };
    case "pl" :
        return {
                TAG: /* Ok */0,
                _0: "pl"
              };
    default:
      return Spice.error(undefined, "Not a valid language", language);
  }
}

var _map$1 = {"BONUS":"BONUS","external":"external","HIGHLIGHT":"HIGHLIGHT","INT":"INT","MAGAZINE":"MAGAZINE","MANUAL_CLIP":"MANUAL_CLIP","PARTNER":"PARTNER","PLAYLIST":"PLAYLIST","PLAYLIST_LIVE":"PLAYLIST_LIVE","SHOW":"SHOW","TOPIC":"TOPIC","TV_SERIES":"TV_SERIES","TRAILER":"TRAILER","VOD":"VOD"};

function programKindToJs(param) {
  return param;
}

function programKindFromJs(param) {
  return _map$1[param];
}

function programKind_encode(programKind) {
  if (programKind === "MAGAZINE") {
    return "MAGAZINE";
  } else if (programKind === "external") {
    return "external";
  } else if (programKind === "HIGHLIGHT") {
    return "HIGHLIGHT";
  } else if (programKind === "PARTNER") {
    return "PARTNER";
  } else if (programKind === "TV_SERIES") {
    return "TV_SERIES";
  } else if (programKind === "INT") {
    return "INT";
  } else if (programKind === "VOD") {
    return "VOD";
  } else if (programKind === "TRAILER") {
    return "TRAILER";
  } else if (programKind === "TOPIC") {
    return "TOPIC";
  } else if (programKind === "PLAYLIST") {
    return "PLAYLIST";
  } else if (programKind === "MANUAL_CLIP") {
    return "MANUAL_CLIP";
  } else if (programKind === "BONUS") {
    return "BONUS";
  } else if (programKind === "SHOW") {
    return "SHOW";
  } else {
    return "PLAYLIST_LIVE";
  }
}

function programKind_decode(programKind) {
  var match = Js_json.decodeString(programKind);
  if (match === undefined) {
    return Spice.error(undefined, "Not a valid programKind", programKind);
  }
  switch (match) {
    case "BONUS" :
        return {
                TAG: /* Ok */0,
                _0: "BONUS"
              };
    case "HIGHLIGHT" :
        return {
                TAG: /* Ok */0,
                _0: "HIGHLIGHT"
              };
    case "INT" :
        return {
                TAG: /* Ok */0,
                _0: "INT"
              };
    case "MAGAZINE" :
        return {
                TAG: /* Ok */0,
                _0: "MAGAZINE"
              };
    case "MANUAL_CLIP" :
        return {
                TAG: /* Ok */0,
                _0: "MANUAL_CLIP"
              };
    case "PARTNER" :
        return {
                TAG: /* Ok */0,
                _0: "PARTNER"
              };
    case "PLAYLIST" :
        return {
                TAG: /* Ok */0,
                _0: "PLAYLIST"
              };
    case "PLAYLIST_LIVE" :
        return {
                TAG: /* Ok */0,
                _0: "PLAYLIST_LIVE"
              };
    case "SHOW" :
        return {
                TAG: /* Ok */0,
                _0: "SHOW"
              };
    case "TOPIC" :
        return {
                TAG: /* Ok */0,
                _0: "TOPIC"
              };
    case "TRAILER" :
        return {
                TAG: /* Ok */0,
                _0: "TRAILER"
              };
    case "TV_SERIES" :
        return {
                TAG: /* Ok */0,
                _0: "TV_SERIES"
              };
    case "VOD" :
        return {
                TAG: /* Ok */0,
                _0: "VOD"
              };
    case "external" :
        return {
                TAG: /* Ok */0,
                _0: "external"
              };
    default:
      return Spice.error(undefined, "Not a valid programKind", programKind);
  }
}

function sticker_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "code",
                    false,
                    Spice.stringToJson(v.code)
                  ],
                  [
                    "label",
                    false,
                    Spice.stringToJson(v.label)
                  ]
                ]));
}

function sticker_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var code = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
  if (code.TAG === /* Ok */0) {
    var label = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                code: code._0,
                label: label._0
              }
            };
    }
    var e = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var duration_in_min_from_js_encode = Spice.intToJson;

function duration_in_min_from_js_decode(v) {
  return Belt_Result.map(Spice.intFromJson(v), (function (v) {
                return v;
              }));
}

var duration_in_sec_from_js_encode = Spice.intToJson;

function duration_in_sec_from_js_decode(v) {
  return Belt_Result.map(Spice.intFromJson(v), (function (v) {
                return v;
              }));
}

function duration_encode(v) {
  if (v.TAG === /* Minute */0) {
    return [
            "Minute",
            Spice.intToJson(v._0)
          ];
  } else {
    return [
            "Second",
            Spice.intToJson(v._0)
          ];
  }
}

function duration_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Minute" :
          if (tagged.length !== 2) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Spice.intFromJson(Belt_Array.getExn(json_arr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Minute */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Second" :
          if (tagged.length !== 2) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Spice.intFromJson(Belt_Array.getExn(json_arr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Second */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

function jsMinDurationToDuration(min) {
  return {
          TAG: /* Minute */0,
          _0: min
        };
}

function jsSecondDurationToDuration(min) {
  return {
          TAG: /* Second */1,
          _0: min
        };
}

function stickers_encode(v) {
  return Spice.arrayToJson(sticker_encode, v);
}

function stickers_decode(v) {
  return Spice.arrayFromJson(sticker_decode, v);
}

function availabilityType_encode(availabilityType) {
  if (availabilityType === "VOD") {
    return "VOD";
  } else if (availabilityType === "LIVESTREAM_WEB") {
    return "LIVESTREAM_WEB";
  } else {
    return "LIVESTREAM_TV";
  }
}

function availabilityType_decode(availabilityType) {
  var match = Js_json.decodeString(availabilityType);
  if (match === undefined) {
    return Spice.error(undefined, "Not a valid availabilityType", availabilityType);
  }
  switch (match) {
    case "LIVESTREAM_TV" :
        return {
                TAG: /* Ok */0,
                _0: "LIVESTREAM_TV"
              };
    case "LIVESTREAM_WEB" :
        return {
                TAG: /* Ok */0,
                _0: "LIVESTREAM_WEB"
              };
    case "VOD" :
        return {
                TAG: /* Ok */0,
                _0: "VOD"
              };
    default:
      return Spice.error(undefined, "Not a valid availabilityType", availabilityType);
  }
}

function availability_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "type_",
                    false,
                    availabilityType_encode(v.type_)
                  ],
                  [
                    "label",
                    false,
                    Spice.optionToJson(Spice.stringToJson, v.label)
                  ],
                  [
                    "start",
                    false,
                    Spice.stringToJson(v.start)
                  ],
                  [
                    "upcomingDate",
                    false,
                    Spice.stringToJson(v.upcomingDate)
                  ]
                ]));
}

function availability_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var type_ = availabilityType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
  if (type_.TAG === /* Ok */0) {
    var label = Spice.optionFromJson(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      var start = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
      if (start.TAG === /* Ok */0) {
        var upcomingDate = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "upcomingDate"), null));
        if (upcomingDate.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    type_: type_._0,
                    label: label._0,
                    start: start._0,
                    upcomingDate: upcomingDate._0
                  }
                };
        }
        var e = upcomingDate._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".upcomingDate" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = start._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".start" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = type_._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".type_" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

var _map$2 = {"AD":"AD","STM":"STM","VF":"VF","VO":"VO","ST":"ST","OV":"OV","UT":"UT","DE":"DE","OmU":"OmU","STE":"STE","ADU":"ADU","BW":"BW","DOL":"DOL","HD":"HD","WID":"WID","WRN":"WRN"};

function audioVersionCodeToJs(param) {
  return param;
}

function audioVersionCodeFromJs(param) {
  return _map$2[param];
}

function audioVersionCode_encode(audioVersionCode) {
  if (audioVersionCode === "BW") {
    return "BW";
  } else if (audioVersionCode === "DE") {
    return "DE";
  } else if (audioVersionCode === "HD") {
    return "HD";
  } else if (audioVersionCode === "OV") {
    return "OV";
  } else if (audioVersionCode === "ST") {
    return "ST";
  } else if (audioVersionCode === "UT") {
    return "UT";
  } else if (audioVersionCode === "VF") {
    return "VF";
  } else if (audioVersionCode === "VO") {
    return "VO";
  } else if (audioVersionCode === "ADU") {
    return "ADU";
  } else if (audioVersionCode === "DOL") {
    return "DOL";
  } else if (audioVersionCode === "OmU") {
    return "OmU";
  } else if (audioVersionCode === "STE") {
    return "STE";
  } else if (audioVersionCode === "STM") {
    return "STM";
  } else if (audioVersionCode === "WID") {
    return "WID";
  } else if (audioVersionCode === "WRN") {
    return "WRN";
  } else {
    return "AD";
  }
}

function audioVersionCode_decode(audioVersionCode) {
  var match = Js_json.decodeString(audioVersionCode);
  if (match === undefined) {
    return Spice.error(undefined, "Not a valid audioVersionCode", audioVersionCode);
  }
  switch (match) {
    case "AD" :
        return {
                TAG: /* Ok */0,
                _0: "AD"
              };
    case "ADU" :
        return {
                TAG: /* Ok */0,
                _0: "ADU"
              };
    case "BW" :
        return {
                TAG: /* Ok */0,
                _0: "BW"
              };
    case "DE" :
        return {
                TAG: /* Ok */0,
                _0: "DE"
              };
    case "DOL" :
        return {
                TAG: /* Ok */0,
                _0: "DOL"
              };
    case "HD" :
        return {
                TAG: /* Ok */0,
                _0: "HD"
              };
    case "OV" :
        return {
                TAG: /* Ok */0,
                _0: "OV"
              };
    case "OmU" :
        return {
                TAG: /* Ok */0,
                _0: "OmU"
              };
    case "ST" :
        return {
                TAG: /* Ok */0,
                _0: "ST"
              };
    case "STE" :
        return {
                TAG: /* Ok */0,
                _0: "STE"
              };
    case "STM" :
        return {
                TAG: /* Ok */0,
                _0: "STM"
              };
    case "UT" :
        return {
                TAG: /* Ok */0,
                _0: "UT"
              };
    case "VF" :
        return {
                TAG: /* Ok */0,
                _0: "VF"
              };
    case "VO" :
        return {
                TAG: /* Ok */0,
                _0: "VO"
              };
    case "WID" :
        return {
                TAG: /* Ok */0,
                _0: "WID"
              };
    case "WRN" :
        return {
                TAG: /* Ok */0,
                _0: "WRN"
              };
    default:
      return Spice.error(undefined, "Not a valid audioVersionCode", audioVersionCode);
  }
}

function audioVersionCodeToIcon(audioVersion, color) {
  if (audioVersion === "BW") {
    return {
            NAME: "BW",
            VAL: color
          };
  } else if (audioVersion === "DE") {
    return {
            NAME: "DE",
            VAL: color
          };
  } else if (audioVersion === "HD") {
    return {
            NAME: "HD",
            VAL: color
          };
  } else if (audioVersion === "OV") {
    return {
            NAME: "OV",
            VAL: color
          };
  } else if (audioVersion === "ST") {
    return {
            NAME: "ST",
            VAL: color
          };
  } else if (audioVersion === "UT") {
    return {
            NAME: "UT",
            VAL: color
          };
  } else if (audioVersion === "VF") {
    return {
            NAME: "VF",
            VAL: color
          };
  } else if (audioVersion === "VO") {
    return {
            NAME: "VO",
            VAL: color
          };
  } else if (audioVersion === "ADU") {
    return {
            NAME: "ADU",
            VAL: color
          };
  } else if (audioVersion === "DOL") {
    return {
            NAME: "DOL",
            VAL: color
          };
  } else if (audioVersion === "OmU") {
    return {
            NAME: "OmU",
            VAL: color
          };
  } else if (audioVersion === "STE") {
    return {
            NAME: "STE",
            VAL: color
          };
  } else if (audioVersion === "STM") {
    return {
            NAME: "STM",
            VAL: color
          };
  } else if (audioVersion === "WID") {
    return {
            NAME: "WID",
            VAL: color
          };
  } else if (audioVersion === "WRN") {
    return {
            NAME: "WRN",
            VAL: color
          };
  } else {
    return {
            NAME: "AD",
            VAL: color
          };
  }
}

function audioVersion_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "code",
                    false,
                    audioVersionCode_encode(v.code)
                  ],
                  [
                    "label",
                    false,
                    Spice.stringToJson(v.label)
                  ]
                ]));
}

function audioVersion_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var code = audioVersionCode_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
  if (code.TAG === /* Ok */0) {
    var label = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                code: code._0,
                label: label._0
              }
            };
    }
    var e = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function audioVersions_encode(v) {
  return Spice.arrayToJson(audioVersion_encode, v);
}

function audioVersions_decode(v) {
  return Spice.arrayFromJson(audioVersion_decode, v);
}

function cmp(a, b) {
  if (a !== b) {
    return 1;
  } else if (a === b) {
    return 0;
  } else {
    return -1;
  }
}

var RelCmp = Belt_Id.MakeComparable({
      cmp: cmp
    });

var add = Belt_Set.add;

function make(value) {
  return Belt_Set.add(Belt_Set.make(RelCmp), value);
}

function toString(t) {
  return Belt_Array.map(Belt_Set.toArray(t), (function (value) {
                  return value;
                })).join(" ");
}

var Rel = {
  add: add,
  make: make,
  toString: toString
};

function watching_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "pct",
                    false,
                    Spice.optionToJson(Spice.floatToJson, v.pct)
                  ],
                  [
                    "time",
                    false,
                    Spice.optionToJson(Spice.intToJson, v.time)
                  ]
                ]));
}

function watching_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var pct = Spice.optionFromJson(Spice.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pct"), null));
  if (pct.TAG === /* Ok */0) {
    var time = Spice.optionFromJson(Spice.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "time"), null));
    if (time.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                pct: pct._0,
                time: time._0
              }
            };
    }
    var e = time._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".time" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = pct._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".pct" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["Watched"];
    } else {
      return ["NotWatched"];
    }
  } else {
    return [
            "Watching",
            watching_encode(v._0)
          ];
  }
}

function t_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NotWatched" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotWatched */0
                  };
          }
      case "Watched" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Watched */1
                  };
          }
      case "Watching" :
          if (tagged.length !== 2) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = watching_decode(Belt_Array.getExn(json_arr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Watching */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

function makeFromPct(time, f) {
  if (f <= 0) {
    return /* NotWatched */0;
  } else if (f > 0 && f < 1) {
    return /* Watching */{
            _0: {
              pct: f * 100,
              time: time
            }
          };
  } else if (f >= 1) {
    return /* Watched */1;
  } else {
    return /* NotWatched */0;
  }
}

function makeFromTimeAndDuration(timeInSec, durationInSec) {
  if (timeInSec <= 0) {
    return /* NotWatched */0;
  } else if (timeInSec > durationInSec || durationInSec <= 0) {
    return ;
  } else {
    return /* Watching */{
            _0: {
              pct: timeInSec / durationInSec * 100,
              time: timeInSec
            }
          };
  }
}

function isGreater(t1, t2) {
  if (typeof t1 === "number") {
    if (t1 !== 0) {
      return true;
    } else {
      return t2 === 0;
    }
  }
  if (typeof t2 === "number") {
    return t2 === 0;
  }
  var watching2 = t2._0;
  var time1 = t1._0.time;
  if (time1 === undefined) {
    return watching2.time === undefined;
  }
  var time2 = watching2.time;
  if (time2 !== undefined) {
    return time1 > time2;
  } else {
    return true;
  }
}

function getPct(t) {
  if (typeof t === "number") {
    if (t !== 0) {
      return 100;
    } else {
      return ;
    }
  } else {
    return t._0.pct;
  }
}

function getTime(t) {
  if (typeof t === "number") {
    return ;
  } else {
    return t._0.time;
  }
}

var Progression = {
  t_encode: t_encode,
  t_decode: t_decode,
  makeFromPct: makeFromPct,
  makeFromTimeAndDuration: makeFromTimeAndDuration,
  noProgression: /* NotWatched */0,
  getPct: getPct,
  getTime: getTime,
  isGreater: isGreater
};

function guide_encode(v) {
  if (v) {
    return ["Tv"];
  } else {
    return ["Concert"];
  }
}

function guide_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Concert" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Concert */0
                  };
          }
      case "Tv" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Tv */1
                  };
          }
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

function trailerBehavior_encode(v) {
  if (v) {
    return ["OnButtonClick"];
  } else {
    return ["Forced"];
  }
}

function trailerBehavior_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Forced" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Forced */0
                  };
          }
      case "OnButtonClick" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* OnButtonClick */1
                  };
          }
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

function pageKind_encode(v) {
  if (typeof v !== "number") {
    if (v.TAG === /* Guide */0) {
      return [
              "Guide",
              guide_encode(v._0)
            ];
    } else {
      return [
              "Rc",
              trailerBehavior_encode(v._0)
            ];
    }
  }
  switch (v) {
    case /* Concert */0 :
        return ["Concert"];
    case /* Direct */1 :
        return ["Direct"];
    case /* Event */2 :
        return ["Event"];
    case /* Genre */3 :
        return ["Genre"];
    case /* Home */4 :
        return ["Home"];
    case /* Program */5 :
        return ["Program"];
    case /* Search */6 :
        return ["Search"];
    case /* SubCategory */7 :
        return ["SubCategory"];
    
  }
}

function pageKind_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Concert" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Concert */0
                  };
          }
      case "Direct" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Direct */1
                  };
          }
      case "Event" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Event */2
                  };
          }
      case "Genre" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Genre */3
                  };
          }
      case "Guide" :
          if (tagged.length !== 2) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = guide_decode(Belt_Array.getExn(json_arr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Guide */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Home" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Home */4
                  };
          }
      case "Program" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Program */5
                  };
          }
      case "Rc" :
          if (tagged.length !== 2) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = trailerBehavior_decode(Belt_Array.getExn(json_arr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Rc */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Search" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Search */6
                  };
          }
      case "SubCategory" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SubCategory */7
                  };
          }
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

exports.linkKindToJs = linkKindToJs;
exports.linkKindFromJs = linkKindFromJs;
exports.geoblocking_encode = geoblocking_encode;
exports.geoblocking_decode = geoblocking_decode;
exports.geoblockingOrdered = geoblockingOrdered;
exports.language_encode = language_encode;
exports.language_decode = language_decode;
exports.programKindToJs = programKindToJs;
exports.programKindFromJs = programKindFromJs;
exports.programKind_encode = programKind_encode;
exports.programKind_decode = programKind_decode;
exports.sticker_encode = sticker_encode;
exports.sticker_decode = sticker_decode;
exports.duration_in_min_from_js_encode = duration_in_min_from_js_encode;
exports.duration_in_min_from_js_decode = duration_in_min_from_js_decode;
exports.duration_in_sec_from_js_encode = duration_in_sec_from_js_encode;
exports.duration_in_sec_from_js_decode = duration_in_sec_from_js_decode;
exports.duration_encode = duration_encode;
exports.duration_decode = duration_decode;
exports.jsMinDurationToDuration = jsMinDurationToDuration;
exports.jsSecondDurationToDuration = jsSecondDurationToDuration;
exports.stickers_encode = stickers_encode;
exports.stickers_decode = stickers_decode;
exports.availabilityType_encode = availabilityType_encode;
exports.availabilityType_decode = availabilityType_decode;
exports.availability_encode = availability_encode;
exports.availability_decode = availability_decode;
exports.audioVersionCodeToJs = audioVersionCodeToJs;
exports.audioVersionCodeFromJs = audioVersionCodeFromJs;
exports.audioVersionCode_encode = audioVersionCode_encode;
exports.audioVersionCode_decode = audioVersionCode_decode;
exports.audioVersionCodeToIcon = audioVersionCodeToIcon;
exports.audioVersion_encode = audioVersion_encode;
exports.audioVersion_decode = audioVersion_decode;
exports.audioVersions_encode = audioVersions_encode;
exports.audioVersions_decode = audioVersions_decode;
exports.Rel = Rel;
exports.Progression = Progression;
exports.guide_encode = guide_encode;
exports.guide_decode = guide_decode;
exports.trailerBehavior_encode = trailerBehavior_encode;
exports.trailerBehavior_decode = trailerBehavior_decode;
exports.pageKind_encode = pageKind_encode;
exports.pageKind_decode = pageKind_decode;
/* RelCmp Not a pure module */
